import Table from '../../../../../../shared/Tables/Table'
import { useRecoilValue } from 'recoil'
import useRegularTable from '../../../../../../shared/Tables/Table/ctrl/useRegularTable.ts'
import maintenanceProcessesTableFields from './maintenanceProcesses.table.fields.tsx'
import maintenanceProcessesAtom from '../../maintenanceProcesses.atom.ts'
import MaintenanceProcessSidePage from '../MaintenanceProcessSidePage'
import useSidePageWithTableCtrl from '@/shared/SidePage/useSidePageWithTableCtrl.ts'

const MaintenanceProcessesTable = () => {
  const items = useRecoilValue(maintenanceProcessesAtom).items
  const sidePageCtrl = useSidePageWithTableCtrl(items)

  const tableCtrl = useRegularTable({
    fields: maintenanceProcessesTableFields,
    tableKey: `maintenance/processes`,
    itemKey: 'id',
    items: items,
  })

  return (
    <>
      <Table
        {...tableCtrl}
        items={items as any}
        itemKey="id"
        onClick={sidePageCtrl.handleItemPageOpen}
        loading={false}
      />
      <MaintenanceProcessSidePage
        open={sidePageCtrl.sidePageOpen}
        onCloseAnimationEnd={sidePageCtrl.handleCloseAnimationEnd}
        onClose={sidePageCtrl.handleClosePage}
        id={sidePageCtrl.selectedItem?.id}
      />
    </>
  )
}

export default MaintenanceProcessesTable
